import { IChallengeListProductItem } from 'interfaces';
import {
  IChallengeResultByProduct,
  TProductDetails,
} from 'interfaces/challenge.types';

export const productDetailsListDataFormatter = (
  challengeProducts: IChallengeListProductItem[],
  challengeResultsByProduct: IChallengeResultByProduct[],
): TProductDetails[] => {
  let productDetailsList: TProductDetails[] = [];
  challengeProducts?.forEach(
    (product: IChallengeListProductItem | undefined) => {
      let productDetails: TProductDetails = {
        reward: product?.reward,
        threshold: product?.threshold,
        coefficient: product?.coefficient,
        productCode: product?.challengeProduct.productCode,
        productName: product?.challengeProduct.productName,
        productDescription: product?.challengeProduct.productDescription,
        range: product?.challengeProduct.range,
        brand: product?.challengeProduct.brand,
        unit: product?.challengeProduct.unit,
        status: product?.challengeProduct.status,
        visual: product?.challengeProduct.visual,
      };
      challengeResultsByProduct?.forEach(
        (productResult: IChallengeResultByProduct) => {
          if (product?.challengeProduct.id === productResult.id) {
            productDetails.quantity = productResult.totalQuantity;
            productDetails.financialValue = productResult.totalFinancialValue;
            productDetails.productRewardValue =
              productResult.challengeProductRewardValue;
            productDetails.productResultValue =
              productResult.challengeProductResultValue;
              productDetailsList.push(productDetails);
          }
        },
      );
    },
  );
  return productDetailsList;
};
